export enum dashboardTypes {
    LOADING = "LOADING",
    GET_DASHBOARD_LIST = "GET_DASHBOARD_LIST",
    GET_DASHBOARD_USER = "GET_DASHBOARD_USER",
}
  
export default dashboardTypes;